import { MenuItem } from 'primeng/api';

/**
 * StyleClass + icon-color fragment that renders a PrimeNG `MenuItem` in the
 * shared error ink (`--p-bd-status-error-color`). Spread onto a `MenuItem` literal:
 *
 * ```ts
 * { label: 'Löschen', icon: 'pi pi-trash', ...BD_DANGER_MENU_ITEM_STYLE,
 *   command: () => this._delete() }
 * ```
 *
 * The accompanying CSS rule lives in each consuming component's `styles:`
 * block (PrimeNG nests the label inside `.p-menu-item-label` /
 * `.p-tieredmenu-item-label`, which can only be reached via `::ng-deep`):
 *
 * ```css
 * ::ng-deep .bd-menu-item-danger .p-menu-item-label {
 *   color: var(--p-bd-status-error-color);
 * }
 * ```
 *
 * Pulling the label styleClass + iconStyle into one constant keeps the
 * danger-tone definition out of the per-component literals and ensures the
 * shareables system stays in sync with `BdResourcesInfoMenuComponent`.
 */
export const BD_DANGER_MENU_ITEM_STYLE: Pick<
  MenuItem,
  'styleClass' | 'iconStyle'
> = {
  styleClass: 'bd-menu-item-danger',
  iconStyle: { color: 'var(--p-bd-status-error-color)' },
};

/**
 * Component-scoped CSS rule that pairs with [[BD_DANGER_MENU_ITEM_STYLE]].
 * Inline this string into a component's `styles:` array so the styleClass
 * actually paints the menu-item label red. Covers both `<p-menu>` and
 * `<p-tieredmenu>` markup.
 */
export const BD_DANGER_MENU_ITEM_CSS = `
  ::ng-deep .bd-menu-item-danger .p-menu-item-label,
  ::ng-deep .bd-menu-item-danger .p-tieredmenu-item-label {
    color: var(--p-bd-status-error-color);
  }
`;
